import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { apiClient } from '../api-client.ts';

export const useSuggestParties = (projectUuid?: string, search?: string) => {
  return useQuery<string[]>({
    queryKey: ['party-suggestions', projectUuid, search],
    queryFn: () =>
      apiClient.get(`/v1/projects/${projectUuid}/patterns/party-suggestions`, {
        params: { search },
      }),
    placeholderData: keepPreviousData,
    enabled: !!projectUuid,
  });
};
